import React from "react";
import { debounce } from "debounce";
import { InputBase } from "./InputBase";
import { observer } from "mobx-react-lite";
//Todo refactor number input into separate component. Remove any from types
const Input = observer(React.forwardRef(({ className, isError: error, errorText = "", min, minErr = "value is too small", max, maxErr = "value is too big", small, icon, trailing, dataCySuffix, ...rest }, ref) => {
    const [internalErr, setInternalErr] = React.useState("");
    const isTypeNumber = rest.type === "number" || min || max;
    const type = isTypeNumber ? "text" : rest.type;
    const value = isTypeNumber ? rest.value ?? "" : rest.value;
    const errorDesc = errorText ?? internalErr;
    const isError = error || (errorDesc != null && errorDesc.length > 0);
    const onChange = (event) => {
        const evt = event;
        if (isTypeNumber) {
            const num = +evt.currentTarget.value;
            if (max && num > max) {
                evt.currentTarget.value = `${max}`;
                rest.onChange(evt);
            }
            if (min && num < min) {
                evt.currentTarget.value = `${min}`;
                rest.onChange(evt);
            }
            !isNaN(num) && rest.onChange(evt);
        }
        else
            rest.onChange(evt);
    };
    const checkSize = (val) => {
        if (min && val < min)
            return setInternalErr(minErr);
        if (max && val > max)
            return setInternalErr(maxErr);
        if (internalErr)
            return setInternalErr("");
    };
    const handleMinMax = React.useCallback(debounce(checkSize, 1000), [
        min,
        minErr,
        max,
        maxErr,
        internalErr,
    ]);
    React.useEffect(() => {
        if (isTypeNumber && value && (min || max)) {
            handleMinMax(value);
        }
    }, [value, min, max]);
    return (React.createElement(InputBase, { isError: isError, errorText: errorDesc, small: small, className: className, ref: ref, trailing: trailing, icon: icon, dataCySuffix: dataCySuffix, ...rest, type, value, onChange }));
}));
export default Input;
//# sourceMappingURL=Input.js.map